import { render, staticRenderFns } from "./Embedo.vue?vue&type=template&id=037a0764&scoped=true&"
import script from "./Embedo.vue?vue&type=script&lang=js&"
export * from "./Embedo.vue?vue&type=script&lang=js&"
import style0 from "./Embedo.vue?vue&type=style&index=0&id=037a0764&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037a0764",
  null
  
)

export default component.exports